export type CacheKey = readonly (string | number)[]

/**
 * Every key for tenant data starts with its ledger. A collision across ledgers shows one
 * household another household's money; the prefix makes that unrepresentable.
 */
export function ledgerKey(ledgerId: string, ...parts: readonly (string | number)[]): CacheKey {
  return ['ledger', ledgerId, ...parts]
}

/** The ledger a key was built for, or undefined for a key that is not ledger-scoped. */
export function ledgerIdOf(key: readonly unknown[]): string | undefined {
  return key[0] === 'ledger' && typeof key[1] === 'string' ? key[1] : undefined
}

export function principalKey(...parts: readonly (string | number)[]): CacheKey {
  return ['principal', ...parts]
}

/** Key prefixes a mutation makes stale, declared beside the mutation rather than at its call site. */
export type Invalidations = readonly CacheKey[]
